/**
 * The variant a listing is — "1TB", "82mm", "E-mount", "ND0.6" — set beside
 * the item name, since siblings of a variant group share that name and differ
 * only here.
 *
 * Mono and case-preserving on purpose: these are spec values, and `.label`
 * would lowercase "1TB" and "E-mount" into something the manufacturer never
 * wrote. The pill never wraps mid-value; put it in a flex-wrap row with the
 * name so a long one drops to its own line. Wrapping only helps while the
 * pill fits ON a line, and labels run to "1.2m right angle mini HDMI" — past
 * the width of a phone-grid catalog cell — so it also caps at the row width
 * and ellipses rather than running off the card.
 */
export function VariantPill({
  label,
  filled = false,
  className = "",
}: {
  label: string;
  /** Give the pill a translucent ground. Needed wherever it sits over a photo
   *  — the catalog cell dims its cover rather than hiding it, and an outline
   *  alone leaves the value reading through product texture. Translucent so
   *  the photo still carries under it instead of being punched out. */
  filled?: boolean;
  /** Type scale for the surface it sits on (default suits card titles). */
  className?: string;
}) {
  return (
    <span
      className={`inline-flex max-w-full shrink-0 items-center overflow-hidden rounded-full border border-line px-2 py-0.5 font-mono text-[0.6875rem] leading-none tracking-[0.02em] ${
        filled ? "bg-bg/70 text-fg" : "text-fg-muted"
      } ${className}`}
    >
      <span className="truncate">{label}</span>
    </span>
  );
}
